import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onLinkClick", "locationTracking", "pathname"];
import { useMemo } from 'react';
export var useHeaderNavigationLinks = function useHeaderNavigationLinks(_ref) {
  var onLinkClick = _ref.onLinkClick,
      locationTracking = _ref.locationTracking,
      pathname = _ref.pathname,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var headerNavigationLinksContextValue = useMemo(function () {
    return {
      onLinkClick: onLinkClick,
      locationTracking: locationTracking,
      pathname: pathname
    };
  }, [onLinkClick, locationTracking, pathname]);
  return {
    result: {
      headerNavigationLinksContextValue: headerNavigationLinksContextValue
    },
    restProps: restProps
  };
};